import PropTypes from "prop-types";
import styles from "./SearchNav.module.scss";
import { connect, CustomContainer } from "../../atoms/DependencyHelper";
import { toggleSearch } from "../../../Redux/actions/navAction";
import { componentCheckSize } from "../../../utils/helperServices";
import SearchBoxContainer from "../SearchBoxContainer/SearchBoxContainer";

const SearchNav = ({
	lableName = "Cancel",
	handleCancel,
	handleChange,
	text,
	handleKeyPress,
	handleSearchClick,
	handleFocus,
}) => {
	const isTablet = componentCheckSize() <= 768;

	const searchBox = (
		<SearchBoxContainer
			focus={true}
			closeRequired={isTablet ? false : true}
			className={styles["search-box"]}
			handleChange={handleChange}
			text={text}
			handleCancel={handleCancel}
			handleKeyPress={handleKeyPress}
			handleSearchClick={handleSearchClick}
			handleFocus={handleFocus}
		/>
	);

	return (
		<>
			{isTablet ? (
				<CustomContainer className={styles["search-container"]}>
					<CustomContainer className={styles["search-items"]}>
						{searchBox}
						<button onClick={handleCancel} className={styles["cancel-btn"]}>
							{lableName}
						</button>
					</CustomContainer>
				</CustomContainer>
			) : (
				<CustomContainer className={styles["search-container"]}>
					<CustomContainer className={styles["search-items"]}>
						{searchBox}
					</CustomContainer>
					<CustomContainer className={styles["horizantal-line"]} />
				</CustomContainer>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	hideNavItems: state.navDetails.hideNavItems,
});

export default connect(mapStateToProps, { toggleSearch })(SearchNav);
